module.exports = __webpack_public_path__ + "img/h5banner_zh_CN.c1aa62d7.jpg";